import { useRouter } from 'next/router'
import { useMemo } from 'react'

import { getLocaleParts } from '@/utils/locale'

export const useLocaleParts = () => {
  const { locale } = useRouter()
  return useMemo(() => {
    const [language, market] = getLocaleParts(locale)
    return { language, market }
  }, [locale])
}
